<template>
  <div>
    <div>
      <!-- <div class="serchCont">
        <div class="serchBox">
          <div class="logoImg img">
            <img src="../../../assets/img/logo-p.png" alt="" srcset="" />
          </div>
          <div class="inpBox">
            <div class="inp">
              <div class="search">
                <div class="iconfont icon-search"></div>
              </div>
              <div class="shu"></div>
              <input
                type="text"
                placeholder="请输入人才关键词搜索"
                v-model="searChTxt"
                @keyup.enter="searchClick"
                name=""
                id=""
              />
              <div class="searchBtn" @click="searchClick">搜索</div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="headCont">
        <div class="addBox dis-cent">
          <div class="text">人才投递简历列表</div>
        </div>
        <div class="slelectCont">
          <div class="ssBox">
            <input
              type="text"
              placeholder="搜索"
              v-model="searChTxt"
              @keyup.enter="searchClick"
            />
            <div
              class="iconfont icon-search search dis-cent"
              @click="searchClick"
            ></div>
          </div>
        </div>
      </div>
      <div class="content">
        <Kong v-if="list.length == 0" />
        <!-- <div class="cont" v-for="item in list" @click="jump(item.member_id)">
          <div class="contLeft">
            <div class="imgBox">
              <div class="img">
                <img :src="$imgUrl + item.member.member_info.avatars" alt="" />
              </div>
              <div class="money dis-cent">
                {{ item.member.jobinfo.minprice }}k-{{
                  item.member.jobinfo.maxprice
                }}k
              </div>
            </div>
          </div>
          <div class="contRit">
            <div class="name">{{ item.member.member_info.realname }}</div>
            <div class="txtBox">
              <div class="txt" v-if="item.age != 2024">{{ item.age }}岁</div>
              <div class="txt" v-if="item.age == 2024">未填写</div>
              <div class="shu"></div>
              <div class="txt">
                {{
                  item.member.member_info.experience_cn
                    ? item.member.member_info.experience_cn
                    : "未填写"
                }}
              </div>
              <div class="shu"></div>
              <div class="txt">
                {{
                  item.member.member_info.current_cn
                    ? item.member.member_info.current_cn
                    : "未填写"
                }}
              </div>
              <div class="shu"></div>
            </div>
            <div class="textBox">
              <div class="txt">期望:</div>
              <div class="text">{{ item.member.jobinfo.intention_jobs }}</div>
            </div>
            <div class="textBox">
              <div class="txt">优势:</div>
              <div class="text c-1">
                {{
                  item.member.member_info.speciality
                    ? item.member.member_info.speciality
                    : "暂未填写优势"
                }}
              </div>
            </div>
            <div class="typeBox">
              <div class="txt" v-if="item.member.member_info.education_cn">
                {{ item.member.member_info.education_cn }}
              </div>
              <template v-if="item.district_cn1">
                <div class="txt" v-for="itemq in item.district_cn1">
                  {{ itemq }}
                </div>
              </template>
              <template v-else>
                <div class="txt">{{ item.member.jobinfo.district_cn }}</div>
              </template>
            </div>
          </div>
          <div class="contJl">
            <div class="lcLi" v-if="item.member.member_experience">
              <div class="iconBox">
                <div class="icon">
                  <div class="iconfont icon--_liepinqiuzhi liepinqiuzhi"></div>
                </div>
                <div class="shu"></div>
              </div>
              <div class="boxs">
                <div class="box" v-for="job in item.member.member_experience">
                  <div class="time">
                    {{ job.start_time ? job.start_time : "未填写" }} -
                    {{ job.end_time ? job.end_time : "未填写" }}
                  </div>
                  <div class="textBox">
                    <div class="text">{{ job.companyname }}</div>
                    <div class="yuan"></div>
                    <div class="text">{{ job.jobs }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="lcLi" v-if="item.member.member_education[0].id != 0">
              <div class="iconBox">
                <div class="icon">
                  <div class="iconfont icon-xuexiao xuexiao"></div>
                </div>
              </div>
              <div class="boxs">
                <div class="box">
                  <div class="time">
                    {{ item.member.member_education[0].start_time }} -
                    {{ item.member.member_education[0].end_time }}
                  </div>
                  <div class="textBox c-1">
                    <div class="text">
                      {{ item.member.member_education[0].school }}
                    </div>
                    <div class="yuan"></div>
                    <div class="text">
                      {{ item.member.member_education[0].speciality }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="goutong dis-cent"
            @click.stop="messageClick(item.member_id)"
          >
            打招呼
          </div>
        </div> -->
        <PeoList :list="list" />
        <div class="fenye" v-if="totalCount > 10">
          <a-pagination
            :default-current="page.pageNo"
            v-model="page.pageNo"
            :total="totalCount"
            :page-size="10"
            @change="pageOnChange"
          />
        </div>
      </div>
    </div>
    <Jianli v-if="jlShow" :id="peoId" @show="jlShowJs" />
    <JobList :member_id="toId" v-if="jobShow" @show="jobShowJs" />
  </div>
</template>

<script>
import {
  Menu,
  Form,
  Input,
  Dropdown,
  Upload,
  Icon,
  message,
} from "ant-design-vue";
import LoginZj from "../../component/loginZj.vue";
import Jianli from "../../component/jianli.vue";
import html2pdf from "html2pdf.js";
import Kong from "../../component/kong.vue";
import JobList from "../../component/jobList.vue";
import PeoList from "../../component/peoList.vue";
export default {
  components: {
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
    LoginZj,
    Jianli,
    Kong,
    JobList,
    PeoList,
  },
  name: "",
  data() {
    return {
      shang: "",
      jobShow: false,
      searChTxt: "",
      typeOn: 0,
      typeList: [
        {
          id: "",
          name: "推荐",
        },
        {
          id: "a.create_time desc",
          name: "新人才",
        },
      ],
      xzList: [],
      jlShow: false,
      xzKey: "选择推荐岗位",
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 10,
        type: 1,
      },
      list: [],
      totalCount: 0,
      category_id: "",
      category_cn: "选择推荐岗位",
      peoId: "",
    };
  },
  created() {
    this.listGet();
  },
  methods: {
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/nozzle/web/resumes_gets", this.page).then((res) => {
        console.log(res);
        this.judge = true;
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          const currentYear = new Date().getFullYear();
          // for (let i = 0; i < res.data.length; i++) {
          //   const e = res.data[i];
          //   if (e.member.member_info.birthday) {
          //     e.age = currentYear - Number(e.member.member_info.birthday);
          //   }
          // }
          this.list = res.data;
        } else {
          this.list = [];
        }
      });
    },
    hyClick(e) {
      this.xzKey = e.key;
    },
    jlShowJs() {
      this.jlShow = false;
      this.canScroll();
    },
    jobShowJs() {
      this.jobShow = false;
    },
    messageClick(id) {
      this.toId = id;
      this.jobShow = true;
    },
    jump(id) {
      this.peoId = id;
      this.jlShow = true;
      this.stopScroll();
    },
    //禁止滚动
    stopScroll() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", mo, false); //禁止页面滑动
    },
    /***取消滑动限制***/
    canScroll() {
      var mo = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = ""; //出现滚动条
      document.removeEventListener("touchmove", mo, false);
    },
    xzClick(i) {
      this.xzList.splice(i, 1);
    },
    delClick() {
      this.xzList = [];
    },
    searchClick() {
      this.page.name = this.searChTxt;
      this.page.pageNo = 1;
      this.list = [];
      this.totalCount = 0;
      this.listGet();
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.headCont {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 10px;
  .addBox {
    display: flex;
    align-items: center;
    height: 35px;
    width: 140px;
    border-radius: 5px;
    background-color: #1a78ec;
    color: #fff;
    padding-right: 5px;
    cursor: pointer;
    .icon-add {
      font-weight: 600;
    }
    .text {
      margin-left: 5px;
    }
  }
  .slelectCont {
    display: flex;
    align-items: center;
    .ssBox {
      height: 35px;
      background-color: #fff;
      width: 260px;
      border-radius: 5px;
      display: flex;
      input {
        width: calc(100% - 35px);
        box-sizing: border-box;
        padding-left: 15px;
      }
      .search {
        width: 35px;
        height: 35px;
        color: #9c9c9c;
        font-size: 18px;
      }
    }
    .lxBox {
      margin-left: 20px;
      height: 35px;
      width: 140px;
      background-color: #fff;
      border-radius: 5px;
      cursor: pointer;
      color: #666;
      .unfold {
        font-size: 14px;
        margin-left: 5px;
      }
    }
  }
}
.serchBox {
  display: flex;
  padding: 25px 55px;
  padding-right: 70px;
  padding-bottom: 5px;
  align-items: center;
  margin-bottom: 20px;
  // justify-content: center;
  .logoImg {
    width: 150px;
  }
  .inpBox {
    width: calc(100% - 160px);
    box-sizing: border-box;
    padding-left: 40px;
    .inp {
      border: 2px solid #1a78ec;
      background-color: #fff;
      width: 100%;
      height: 50px;
      border-radius: 10px;
      display: flex;
      overflow: hidden;
      align-items: center;
      position: relative;
      .search {
        width: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        .iconfont {
          font-size: 24px;
          color: #999;
        }
      }
      .shu {
        width: 2px;
        height: 20px;
        background-color: #c9c9c9;
      }
      input {
        width: calc(100% - 67px);
        height: 100%;
        padding-left: 20px;
        box-sizing: border-box;
      }
      .searchBtn {
        cursor: pointer;
        width: 90px;
        height: calc(100% - 4px);
        position: absolute;
        right: 2px;
        top: 2px;
        background-color: #1a78ec;
        color: #fff;
        font-weight: 600;
        font-size: 16px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
.content {
  .cont {
    cursor: pointer;
    width: 100%;
    border-radius: 5px;
    background-color: #fff;
    padding: 15px 20px;
    margin-bottom: 15px;
    display: flex;
    .contLeft {
      width: 60px;
      .imgBox {
        width: 60px;
        .img {
          height: 60px;
          width: 60px;
          border-radius: 50%;
          img {
            border-radius: 50%;
          }
        }
        .money {
          width: 60px;
          height: 20px;
          border-radius: 20px;
          background-color: #f34e1c;
          color: #fff;
          margin-top: 10px;
          font-size: 12px;
          font-weight: 600;
        }
      }
    }
    .contRit {
      width: calc(45% - 60px);
      padding-left: 25px;
      box-sizing: border-box;
      padding-right: 25px;
      .name {
        font-weight: 500;
        font-size: 16px;
      }
      .txtBox {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-top: 5px;
        .shu {
          width: 1px;
          height: 13px;
          background-color: #c9c9c9;
          margin: 0 8px;
        }
        .shu:last-child {
          display: none;
        }
      }
      .textBox {
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-top: 5px;
        .txt {
          color: #999;
          width: 35px;
        }
        .text {
          width: calc(100% - 35px);
        }
        .texts {
          display: flex;
          align-items: center;
          width: calc(100% - 35px);
          .yuan {
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #c9c9c9;
            margin: 0 6px;
          }
        }
      }
      .typeBox {
        display: flex;
        margin-top: 10px;
        .txt {
          padding: 3px 6px;
          background-color: #f0f3f7;
          margin-right: 10px;
          border-radius: 5px;
          color: #333;
          font-size: 12px;
        }
      }
    }
    .contJl {
      width: calc(55% - 80px);
      display: flex;
      flex-direction: column;
      justify-content: center;
      .lcLi {
        display: flex;
        width: 100%;
        font-size: 13px;
        .iconBox {
          width: 22px;
          display: flex;
          align-items: center;
          flex-direction: column;
          color: #b4b4b4;
          .icon {
            width: 16px;
            height: 20px;
            overflow: hidden;
          }
          .shu {
            border-left: 1px dashed #dadada;
            width: 1px;
            height: calc(100% - 20px);
          }
          .xuexiao {
            font-size: 19px;
            position: relative;
            top: -5px;
            left: -1px;
          }
          .liepinqiuzhi {
            font-size: 14px;
            position: relative;
            left: 1px;
          }
        }
        .boxs {
          width: calc(100% - 22px);
          .box {
            padding-left: 10px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            margin-bottom: 5px;
            .time {
              width: 130px;
              color: #9c9c9c;
            }
            .textBox {
              width: calc(100% - 130px);
              display: flex;
              align-items: center;
              .yuan {
                width: 5px;
                height: 5px;
                border-radius: 50%;
                background-color: #c9c9c9;
                margin: 0 10px;
              }
            }
          }
        }
      }
    }
    .goutong {
      background-color: #147ee0;
      color: #fff;
      height: 40px;
      width: 80px;
      border-radius: 5px;
    }
  }
}
</style>
